<template>
    <v-autocomplete
        :items="data"
        item-text="plate_number"
        item-value="plate_number"
        v-bind="$props"
        :loading="loading"
        @change="$emit('change', $event)"
        @keypress.enter="$emit('enter', $event)"
        >
    </v-autocomplete>
</template>

<script>
import { getTrucks } from './../services/reports'
export default {
    props:{
        outlined:Boolean,
        dense:Boolean,
        backgroundColor:String,
        hideDetails:Boolean
    },
    data() {
        return {
            data:[],
            loading: false
        }
    },
    methods:{
        async fetchTrucks() {
            this.loading = true
            let response = await getTrucks()
            //console.log(response)
            this.data = response.data.data
            this.loading = false  
        }
        // truckDetialsData(data) {
        //     let object = {}
        //     for(let i in data){
                
        //     }
        // }
    },
    created() {
        this.fetchTrucks()
    }
}
</script>

<style>

</style>